import { useMutation } from '@tanstack/react-query';

const EDHREC_API_URL = 'https://edhrec.com/api/recs';

export interface EDHRecCard {
  name: string;
  oracle_id: string;
  primary_type: string;
  salt: number | { source: string; parsedValue: number };
  names: string[];
  score: number;
}

export interface EDHRecRequest {
  cards: string[];
  commanders: string[];
  name?: string;
  options?: {
    excludeLands?: boolean;
    offset?: number;
  };
}

export interface EDHRecResponse {
  inRecs: EDHRecCard[];
}

export function useEDHRec() {
  return useMutation<EDHRecCard[], Error, EDHRecRequest>({
    mutationKey: ['edhrec'],
    mutationFn: async (body) => {
      const response = await fetch(EDHREC_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch EDHREC recommendations');
      }

      const json: EDHRecResponse = await response.json();
      return json.inRecs;
    },
  });
}
